export function mapContractorToOption (item) {
  return {
    long_name: item.long_name + (item.short_name ? ` (${item.short_name})` : ''),
    id: item.id
  }
}
